<section class="app-cit-pla">
  <img
    class="app-cit-pla__img"
    [alt]="'Plan wyjazdu'"
    [src]="img()"
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.5"
    [delay]="'500'"
  />
  <div class="app-cit-pla__txt" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'500'">
    <div class="app-cit-pla__txt__tit">PLAN WYJAZDU</div>
    @for (d of plan(); track $index) {
      <app-city-plan-exp [day]="d" />
    }
  </div>
</section>
